import {
  ADD_FAVOURITE_ISSUE,
  ADD_FAVOURITE_ISSUE_SUCCESS,
  FETCH_ISSUE,
  FETCH_ISSUE_SUCCESS,
  FETCH_ALL_ISSUE,
  FETCH_ALL_ISSUE_SUCCESS,
  FILTER_ISSUE,
  GET_ALL_ISSUE,
  GET_UNSELECTED_ALL_ISSUE,
  HANDLE_ISSUE_REQUEST_CLOSE,
  HIDE_ISSUE_LOADER,
  SHOW_ISSUE_LOADER,
  ON_ADD_ISSUE,
  ON_EDIT_ISSUE,
  SET_ISSUE,
  ON_ALL_ISSUE_SELECT,
  ON_ISSUE_CLOSE,
  ON_ISSUE_SELECT,
  ON_DELETE_ISSUE,
  ON_DELETE_ISSUE_SUCCESS,
  ON_FILTER_SELECTED_ISSUE,
  ON_FILTER_ISSUE_OPTION_SELECT,
  ON_SAVE_ISSUE,
  ON_SAVE_ISSUE_SUCCESS,
  ON_TOGGLE_ISSUE_DRAWER,
  SHOW_ISSUE_MESSAGE,
  UPDATE_SEARCH_ISSUE,
  ON_FETCH_SELECT_FEATURE_DATA,
  ON_FETCH_SELECT_FEATURE_DATA_SUCCESS,
  ON_ISSUE_FEATURE_UPDATE,
} from 'constants/ActionTypes';

export const onIssueFeatureUpdate = () => {
  return {
      type: ON_ISSUE_FEATURE_UPDATE,
  };
};
export const onFetchSelectFeatureData = () => {
  return {
      type: ON_FETCH_SELECT_FEATURE_DATA,
  };
};
export const onFetchSelectFeatureDataSuccess = (payload) => {
  return {
      type: ON_FETCH_SELECT_FEATURE_DATA_SUCCESS,
      payload
  };
};
export const setIssue = (payload) => {
  return {
      type: SET_ISSUE,
      payload
  };
};
export const fetchIssue = (payload) => {
  return {
      type: FETCH_ISSUE,
      payload
  };
};
export const fetchIssueSuccess = (payload) => {
  return {
      type: FETCH_ISSUE_SUCCESS,
      payload
  };
};
export const fetchIssues = () => {
  return {
      type: FETCH_ALL_ISSUE
  };
};
export const fetchIssuesSuccess = (payload) => {
  return {
      type: FETCH_ALL_ISSUE_SUCCESS,
      payload
  };
};
export const showIssueMessage = (message) => {
  return {
      type: SHOW_ISSUE_MESSAGE,
      payload: message
  };
};
export const addFavouriteIssue = (payload) => {
  return {
      type: ADD_FAVOURITE_ISSUE,
      payload
  };
};
export const addFavouriteIssueSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_ISSUE_SUCCESS,
      payload
  };
};
export const onIssueSelect = (payload) => {
  return {
      type: ON_ISSUE_SELECT,
      payload
  };
};
export const onAddIssue = () => {
  return {
      type: ON_ADD_ISSUE,
  };
};
export const onEditIssue = (payload) => {
  return {
      type: ON_EDIT_ISSUE,
      payload
  };
};
export const onIssueClose = () => {
  return {
      type: ON_ISSUE_CLOSE,
  };
};
export const onFilterIssueOptionSelect = (payload) => {
  return {
      type: ON_FILTER_ISSUE_OPTION_SELECT,
      payload
  };
};
export const onSaveIssue = (payload) => {
  return {
      type: ON_SAVE_ISSUE,
      payload
  };
};
export const onSaveIssueSuccess = (data) => {
  return {
      type: ON_SAVE_ISSUE_SUCCESS,
      payload: data
  };
};
export const onDeleteIssue = (payload) => {
  return {
      type: ON_DELETE_ISSUE,
      payload
  };
};
export const onDeleteIssueSuccess = (payload) => {
  return {
      type: ON_DELETE_ISSUE_SUCCESS,
      payload
  };
};
export const onFilterSelectedIssue = () => {
  return {
      type: ON_FILTER_SELECTED_ISSUE,
      payload: ''
  };
};
export const filterIssue = (payload) => {
  return {
      type: FILTER_ISSUE,
      payload
  };
};
export const getAllIssue = () => {
  return {
      type: GET_ALL_ISSUE,
      payload: ''
  };
};
export const getUnselectedAllIssue = () => {
  return {
      type: GET_UNSELECTED_ALL_ISSUE,
      payload: ''
  };
};
export const onAllIssueSelect = () => {
  return {
      type: ON_ALL_ISSUE_SELECT,
      payload: ''
  };
};
export const updateSearchIssue = (payload) => {
  return {
      type: UPDATE_SEARCH_ISSUE,
      payload
  };
};
export const onToggleIssueDrawer = () => {
  return {
      type: ON_TOGGLE_ISSUE_DRAWER,
  };
};
export const handleIssueRequestClose = () => {
  return {
      type: HANDLE_ISSUE_REQUEST_CLOSE,
  };
};
export const showIssueLoader = () => {
  return {
      type: SHOW_ISSUE_LOADER,
  };
};
export const hideIssueLoader = () => {
  return {
      type: HIDE_ISSUE_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/issue.js